import {Component, ElementRef, EventEmitter, Output, ViewChild} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {ModalController} from 'ionic-angular';
import {ImageEntity} from '../../../../shared/entities/image';
import {ImageContentForm} from '../../../image/form/image-content.form';
import {ImageFormService} from '../../services/image-form/image-form-service';
import {ImageUploadService} from '../../services/image-upload/image-upload-service';
import {EditImageModalComponent} from '../edit-image-modal';

/**
 * Class for the ImageUploadComponent
 * @class
 */
@Component({
  selector: 'advtech-image-upload',
  templateUrl: './image-upload.component.html',
})
export class ImageUploadComponent {

  /**
   * The image upload input element
   * @type {ElementRef}
   */
  @ViewChild('imageInput')
  inputElement: ElementRef;

  /*
  * Output for a successful upload
  * @type {EventEmitter<any>}
  */
  @Output()
  onUpload: EventEmitter<any> = new EventEmitter();

  imageFormData;

  /**
   * @constructor
   * @param {ImageUploadService} uploadService
   * @param {ImageFormService} formService
   * @param {FormBuilder} formBuilder
   * @param {ModalController} modalCtrl
   */
  constructor(private uploadService: ImageUploadService,
              private formService: ImageFormService,
              private formBuilder: FormBuilder,
              private modalCtrl: ModalController) {
  }

  /**
   * Clicks the input element to upload an image when we click the Upload button
   * @returns {void}
   */
  hInputElementClick(): void {
    this.inputElement.nativeElement.value = null;
    this.inputElement.nativeElement.click();
  }

  /**
   * Upload the image to Prism
   * @param {Event} event The input event
   * @returns {void}
   */
  hChange(event: any): void {
    const file = this.inputElement.nativeElement.files[0];
    const formData = new FormData();
    formData.append('upfile', file);

    setTimeout(() => {
      this.uploadService.sendImage(formData).subscribe((data) => {
        this.getFormStructure(data, data.id);
      });
    }, 100);
  }

  getFormStructure(imageUploadData, id: string) {
    this.formService.getEditObject('mobile/content/content_image/' + id).subscribe((imageFormData) => {
      this.createForm({imageUploadData, imageFormData, path: imageUploadData.path});
    });
  }

  /**
   * Creates ImageEntity and imageForm when image has uploaded, sends ImageFormItem with the form data and
   * image path together to the ImagePickerComponent
   * @param {any} imageData The image to be made into a imageForm, contains {imageUploadData, imageFormData, imagePath}
   * @returns {void}
   *
   */
  createForm(imageData: any): void {
    this.imageFormData = imageData.imageFormData;
    const imageFields = this.imageFormData.form.images.children[0].children;

    const imageEntity = new ImageEntity({data: imageFields, id: imageFields.id.value});
    const imageForm = new ImageContentForm(this.formBuilder, imageEntity);
    const imageFormItem = {imageForm, path: imageData.path};

    this.hImageUpload(imageFormItem);
  }

  /**
   * Open the Edit Image Modal for editing the image
   * @param {any} formItem The image form data
   * @returns {Promise<any>}
   */
  hImageUpload(formItem: any): Promise<any> {
    const cropGravityChoices = this.imageFormData.form.images.children[0].children.cropGravity.choices;

    const editImageModal = this.modalCtrl.create(EditImageModalComponent,
      {imageFormItem: formItem, cropGravityChoices});

    editImageModal.onDidDismiss((data) => this.hImageModalDismiss(data));
    return editImageModal.present();
  }

  hImageModalDismiss(data) {
    this.onUpload.emit(data);
  }
}


// WEBPACK FOOTER //
// ./src/app/content/shared/components/image-upload/image-upload.component.ts